define('views/modules/template/custom/custom-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/i18n',
    'services/session',
    'services/api',
    // Events
    'services/layout',
    'services/events/template-events',
    // views
    'views/parts/menu/menu-action',
    'views/modules/template/list/template-list',
    'views/parts/alert/alert-no-data',
    // models & collections
    'collections/template/templates',
    'models/template/template',
    // templates
    'text!templates/modules/template/custom/custom-content.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    i18n,
    Session,
    API,
    //Events
    LayoutState,
    TemplateEvents,
    // views
    VMenuAction,
    VTemplateList,
    VAlertNoData,
    // models & collections
    CTemplates,
    MTemplate,
    // templates
    TCustomContent
) {

    var VCustomContent = Backbone.View.extend({
        template: TCustomContent,

        regions: {
            root: ".custom-content",
            menu: ".menu-actions",
            list: ".custom-template-list",
            alert: ".alert-no-data"
        },

        initialize: function(opt) {
            opt = opt || {};

            _.extend(this, {
                profile: this.model,
                group: opt.group,
                url: opt.url
            });

            var collection = this.collection = new CTemplates();
            this.collection.comparator = 'name';

            var view = this.view = {
                    menu: new VMenuAction({
                        context: this,
                        onClick: this.onActionClick,
                        collection: new Backbone.Collection([
                            { title: i18n.t('messages:tooltip-create-template'), itemClass: 'big-action', content: '<strong>+</strong>', callback: this.onTemplateAdd },
                        ]),
                        tooltip: { container: this.regions.root }
                    }),
                    list: new VTemplateList({
                        collection: collection,
                        title: 'Your templates',
                        profile: this.profile,
                        group: this.group,
                        bottom: true
                    }),
                    alert: new VAlertNoData({
                        title: 'template:Add your first template',
                        subtitle: 'template:Click on plus',
                        collection: collection,
                        addClass: 'alert-arrow alert-arrow-left-top',
                    }),
                };

            this.listenTo(collection, {
                'template:edit': this.onTemplateEdit,
                'template:add': this.onTemplateAdd,
                'template:duplicate': this.onTemplateDuplicate,
                'template:displayAssignment': this.onDisplayAssignmentPanelAction,
                'remove': this.onTemplateRemove
            });
        },

        render: function() {
            this.initListener();
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var zone = this.zone,
                view = this.view;

            this.assign(view.menu, zone.$menu)
                .assign(view.alert, zone.$alert)
                .assign(view.list, zone.$list);

            this.collection.fetch();
        },

        initListener: function() {
            this.stopListeningTo(TemplateEvents);
            this.listenTo(TemplateEvents, {
                "template:change": this.onTemplateChange,
            });
        },

        unselect: function() {
            this.$('.template-list-item.active').removeClass('active');
        },

        ////////////
        // actions //
        ////////////

        onActionClick: function(e) {
            e.preventDefault();
        },

        ////////////
        // events //
        ////////////
        onDisplayAssignmentPanelAction: function(model) {
            this.unselect();
            Backbone.history.navigate(Mustache.render(this.url + '{{templateId}}/assignment/', {
                groupId: this.group.id,
                templateId: model.id
            }), { trigger: true });
            this.trigger('template:edit');
        },

        onTemplateEdit: function(model) {
            this.unselect();
            Backbone.history.navigate(Mustache.render(this.url + '{{templateId}}', {
                groupId: this.group.id,
                templateId: model.id
            }), { trigger: true });
            this.trigger('template:edit');
        },

        onTemplateDuplicate: function(model) {
            this.unselect();

            ///API Endpoint : groups/58c16602be11042fec7842a1/templates/59e64b13be110409632dc4b7/duplicate/
            var url = API.url(Mustache.render('groups/{{groupId}}/templates/{{templateId}}/duplicate/', {
                          groupId: this.group.id,
                          templateId: model.id
                      }));

            Backbone.ajax(
                _.extend({
                    url: url,
                    method: "GET",
                    async: false,
                    context: this,
                }, {

                    success: function(response, textStatus, xhr) {
                        var self = this;
                        if (textStatus === 'success') {
                            var dupTemplate = new MTemplate({ _id: response._id });
                            dupTemplate.fetch({ context: this,
                                                success: function() {
                                                    this.collection.set(dupTemplate, { remove: false });
                                                    this.collection.sort();
                                                    this.view.list.render();
                                                    this.view.list.selectTemplateItem(dupTemplate);
                                                    Backbone.history.navigate(Mustache.render(this.url + '{{templateId}}', {
                                                        groupId: this.group.id,
                                                        templateId: dupTemplate.id
                                                    }), { trigger: true });
                                                    this.trigger('template:edit');
                                                } });
                        }
                    },
                    error: function(xhr, errmsg, err) {
                        window.Rollbar.error("Error while duplicating template in custom-content.js", err);
                    },
                })
            );
        },

        isTemplateBuilderOpened: function() {
            return Backbone.history.getFragment().includes('template');
        },

        onTemplateRemove: function() {
            if (this.isTemplateBuilderOpened()) {
                if (this.collection.length > 0) {
                    this.collection.first().trigger('setItemActive');
                    Backbone.history.navigate(Mustache.render(this.url + this.collection.first().id, {
                        groupId: this.group.id,
                    }), { trigger: true });
                } else {
                    this.onTemplateAdd();
                }
            }
        },

        onTemplateAdd: function() {
            this.unselect();
            Backbone.history.navigate(Mustache.render(this.url, {
                groupId: this.group.id,
            }), { trigger: true });
            this.trigger('template:add');
        },

        onTemplateChange: function(model) {
            this.collection.set(model, { remove: false });
        },

        onDisable: function() {
            this.stopListeningTo(TemplateEvents);
        },

    });

    return VCustomContent;

});

